export const TOKEN_NAME = "lavoris:tokens";
export const REFRESH_PATH = `/${process.env.REACT_APP_API_LAVORIS_VERSION}/auth/refresh`;
export const LOGIN_PATH = `/${process.env.REACT_APP_API_LAVORIS_VERSION}/auth/login`;